import React from 'react'

import {EntitySelectorEntityType} from "../selector"
import {MentionOption} from "../../editor/plugins/mentions/option"
import EntitySelectorUsers from "./user/user"
import EntitySelectorTasks from "./task/task"
import EntitySelectorDocuments from "./document/document"
import EntitySelectorProjects from "./project/project"

type Props = {
    currentEntityType   : EntitySelectorEntityType
    userMentions        : MentionOption[]
    projectId?          : ID

    onEntitySelected    : {(entity:MentionOption):void}
    onTab               : {():void}
}

const debug = false
// const debug = "EntitySelectorMain"

export default function EntitySelectorMain (props:Props) {

    switch (props.currentEntityType) {
        case EntitySelectorEntityType.USER      :
            return <EntitySelectorUsers  userMentions       = {props.userMentions}
                                         onEntitySelected   = {props.onEntitySelected}
                                         onTab              = {props.onTab}/>

        case EntitySelectorEntityType.TASK      :
            return <EntitySelectorTasks projectId           = {props.projectId}
                                        onEntitySelected    = {props.onEntitySelected}
                                        onTab               = {props.onTab}/>

        case EntitySelectorEntityType.DOCUMENT  :
            return <EntitySelectorDocuments projectId           = {props.projectId}
                                            onEntitySelected    = {props.onEntitySelected}
                                            onTab               = {props.onTab}/>

        case EntitySelectorEntityType.PROJECT   :
            return <EntitySelectorProjects projectId        = {props.projectId}
                                           onEntitySelected = {props.onEntitySelected}
                                           onTab            = {props.onTab}/>
    }
}
